// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__1Y67r","skeleton_user":"Skeleton_skeleton_user__3fVmR","img":"Skeleton_img__10AX7","content":"Skeleton_content__3XpCZ","row":"Skeleton_row__1hJp8"};